import {
  Button,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Flex,
  SimpleGrid,
  Text,
  Box,
  HStack,
  VStack,
  Divider,
} from "@chakra-ui/react";
import { brandPalette } from "../../../constants/brandPalette";
import React, { useEffect, useState } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import { MdOutlineLogout, MdWarningAmber } from "react-icons/md";
import { RiFileEditLine, RiForbid2Line, RiQrScan2Line, RiLockPasswordLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { RiFileExcel2Line, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CTable from "../../../components/Table/table";
import { adminPillSelectStyles } from "../../../components/Models/admin-modal-theme";
import ExportUsersButton from "./exportcsv";
import {
  openCreateStudent,
  openStudentReportModel,
  openUserQRCodeModel,
  openSuspendReasonModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  approvedStudentsListRequest,
  approveStudentRequest,
  clearSessionRequest,
  deleteStudentRequest,
  rejectStudentRequest,
  restrictStudentRequest,
  studentsRequestsListRequest,
  resendPasswordRequest,
  addBulkStudentRequest,
} from "../../../modules/admin-modules/students/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import SuspendReasonModal from "./models/suspend-reason";

const CirclesStudentsTable = ({ setAdd, setSelectedData, searchTerm, setSearchTerm }) => {
  const approvedStudents = useSelector(
    (state) => state.students.approvedStudents
  );
  const pendeingStudents = useSelector(
    (state) => state.students.pendeingStudents
  );
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);
  const isRestrict = useSelector((state) => state.students.isRestrict);
  const isSuspend = useSelector((state) => state.students.isSuspend);

  const [offset, setPage] = useState(0);
  const [tab, setTab] = useState("approve");
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [studentGroupId, setStudentGroupId] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });
  const [suspendStudent, setSuspendStudent] = useState(null);
  const studentsList = tab === "approve" ? approvedStudents : pendeingStudents;
  const groups = useSelector((state) => state.groups.groups);
  const userData = useSelector((state) => state.user.userData);
  const isSuperAdmin = userData?.role?.[0]?.name === "Super Admin";

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      tab === "approve"
        ? dispatch(approvedStudentsListRequest(pageNumber + 1, searchTerm, studentGroupId))
        : dispatch(studentsRequestsListRequest(pageNumber + 1, searchTerm));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab, studentGroupId, dispatch]);

  // Function to format phone number for WhatsApp
  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;

    // Remove all spaces, dashes, brackets, and parentheses
    let cleaned = phone.toString().replace(/[\s\-\(\)\[\]]/g, '');

    // Check if it's an Egyptian number (starts with 012, 011, 010, 015)
    if (cleaned.match(/^(012|011|010|015)/)) {
      // Keep the 0 and add country code 2 before it
      cleaned = '2' + cleaned;
    } else {
      // Remove leading + or 00
      if (cleaned.startsWith('+')) {
        cleaned = cleaned.substring(1);
      } else if (cleaned.startsWith('00')) {
        cleaned = cleaned.substring(2);
      }
    }

    return cleaned;
  };

  const viewData = (data) => {
    // Find the original student data from studentsList to preserve original values (not JSX)
    const originalData = studentsList?.find((student) => student.id === data?.id);
    if (originalData) {
      setSelectedData(originalData);
      setSelected(originalData);
    } else {
      setSelectedData(data);
      setSelected(data);
    }
  };

  const renderPhoneWithWa = (phone) => (
    <HStack spacing={2} alignItems="center" flexWrap="wrap">
      <Text wordBreak="break-word">{phone}</Text>
      {phone && (
        <IconButton
          as="a"
          href={`https://wa.me/${formatPhoneForWhatsApp(phone)}`}
          target="_blank"
          rel="noopener noreferrer"
          variant="ghost"
          size="sm"
          colorScheme="green"
          aria-label="WhatsApp"
          icon={<FaWhatsapp />}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </HStack>
  );

  const renderQrTrigger = (data) => (
    <IconButton
      variant="outline"
      border="0"
      color="gray.600"
      aria-label="Show student QR code"
      fontSize="20px"
      icon={<RiQrScan2Line />}
      flexShrink={0}
      onClick={(e) => {
        e.stopPropagation();
        viewData(data);
        dispatch(openUserQRCodeModel());
      }}
      sx={{
        'html[data-theme="dark"] &': {
          color: "var(--text-primary)",
        },
      }}
    />
  );

  const renderApprovedActionsToolbar = (data) => (
    <Box
      display="flex"
      width="100%"
      maxW="100%"
      borderRadius="xl"
      border="1px solid"
      borderColor="var(--border-subtle)"
      bg="var(--surface-muted)"
      p="4px"
      onClick={(e) => e.stopPropagation()}
    >
      <HStack spacing={0.5} justify="center" flexWrap="wrap" width="100%" rowGap={1}>
        <IconButton
          aria-label={data?.deleted_at == null ? "Suspend student" : "Restore student"}
          size="sm"
          borderRadius="lg"
          minW="38px"
          h="38px"
          variant="ghost"
          bg={data?.deleted_at == null ? "red.50" : "green.50"}
          color={data?.deleted_at == null ? "red.500" : "green.600"}
          _hover={{
            bg: data?.deleted_at == null ? "red.100" : "green.100",
          }}
          sx={{
            'html[data-theme="dark"] &': {
              bg: data?.deleted_at == null ? "rgba(248, 113, 113, 0.22)" : "rgba(74, 222, 128, 0.2)",
              color: data?.deleted_at == null ? "#fecaca" : "#bbf7d0",
            },
            'html[data-theme="dark"] &:hover': {
              bg: data?.deleted_at == null ? "rgba(248, 113, 113, 0.35)" : "rgba(74, 222, 128, 0.32)",
            },
          }}
          fontSize="18px"
          icon={<MdWarningAmber />}
          onClick={(e) => {
            e.stopPropagation();
            if (data?.deleted_at != null) {
              dispatch(deleteStudentRequest(data?.id));
            } else {
              setSuspendStudent(data);
              dispatch(openSuspendReasonModel());
            }
          }}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
        <IconButton
          aria-label="Clear session"
          size="sm"
          borderRadius="lg"
          minW="38px"
          h="38px"
          variant="ghost"
          bg="gray.100"
          color="gray.600"
          _hover={{ bg: "gray.200" }}
          sx={{
            'html[data-theme="dark"] &': {
              bg: "rgba(255, 255, 255, 0.08)",
              color: "var(--text-primary)",
            },
            'html[data-theme="dark"] &:hover': {
              bg: "rgba(255, 255, 255, 0.14)",
            },
          }}
          fontSize="18px"
          icon={<MdOutlineLogout />}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(clearSessionRequest(data?.id));
          }}
        />
        <IconButton
          aria-label={data?.restrict == 0 ? "Restrict student" : "Remove restriction"}
          size="sm"
          borderRadius="lg"
          minW="38px"
          h="38px"
          variant="ghost"
          isLoading={selected.id == data?.id ? isRestrict : false}
          bg={data?.restrict == 0 ? "red.50" : "green.50"}
          color={data?.restrict == 0 ? "red.500" : "green.600"}
          _hover={{
            bg: data?.restrict == 0 ? "red.100" : "green.100",
          }}
          sx={{
            'html[data-theme="dark"] &': {
              bg: data?.restrict == 0 ? "rgba(248, 113, 113, 0.22)" : "rgba(74, 222, 128, 0.2)",
              color: data?.restrict == 0 ? "#fecaca" : "#bbf7d0",
            },
            'html[data-theme="dark"] &:hover': {
              bg: data?.restrict == 0 ? "rgba(248, 113, 113, 0.35)" : "rgba(74, 222, 128, 0.32)",
            },
          }}
          fontSize="18px"
          icon={<RiForbid2Line />}
          onClick={(e) => {
            e.stopPropagation();
            const formData = new FormData();
            formData.append("_method", "PUT");
            data?.restrict == 0
              ? formData.append("restrict", 0)
              : formData.append("restrict", 1);
            dispatch(
              restrictStudentRequest({
                id: data?.id,
                formData: formData,
              })
            );
          }}
        />
        <IconButton
          aria-label="Resend password"
          size="sm"
          borderRadius="lg"
          minW="38px"
          h="38px"
          variant="ghost"
          bg="purple.50"
          color="purple.600"
          _hover={{ bg: "purple.100" }}
          sx={{
            'html[data-theme="dark"] &': {
              bg: "rgba(192, 132, 252, 0.22)",
              color: "#e9d5ff",
            },
            'html[data-theme="dark"] &:hover': {
              bg: "rgba(192, 132, 252, 0.34)",
            },
          }}
          fontSize="18px"
          icon={<RiLockPasswordLine />}
          onClick={(e) => {
            e.stopPropagation();
            setSelected({ id: data?.id });
            dispatch(resendPasswordRequest(data?.id));
          }}
          isLoading={selected.id === data?.id ? isLoading : false}
        />
        <IconButton
          aria-label="Edit student"
          size="sm"
          borderRadius="lg"
          minW="38px"
          h="38px"
          variant="ghost"
          bg="blue.50"
          color="blue.600"
          _hover={{ bg: "blue.100" }}
          sx={{
            'html[data-theme="dark"] &': {
              bg: "rgba(96, 165, 250, 0.22)",
              color: "#bfdbfe",
            },
            'html[data-theme="dark"] &:hover': {
              bg: "rgba(96, 165, 250, 0.36)",
            },
          }}
          fontSize="18px"
          icon={<RiFileEditLine />}
          onClick={(e) => {
            e.stopPropagation();
            setAdd(false);
            setSelectedData(data);
            dispatch(openCreateStudent());
          }}
        />
      </HStack>
    </Box>
  );

  const renderPendingActionsToolbar = (data) => (
    <HStack spacing={3} justify="flex-end" flexWrap="wrap">
      <IconButton
        variant="outline"
        border="0"
        color="gray.600"
        aria-label="Approve student"
        fontSize="40px"
        icon={<FcApprove style={{ fontSize: "40px" }} />}
        onClick={() => dispatch(approveStudentRequest(data?.id))}
        isLoading={selected.id == data?.id ? isSuspend : false}
      />
      <IconButton
        variant="outline"
        border="0"
        color="gray.600"
        aria-label="Reject student"
        fontSize="20px"
        icon={<FcDisapprove style={{ fontSize: "40px" }} />}
        onClick={() => dispatch(rejectStudentRequest(data?.id))}
        isLoading={selected.id == data?.id ? isRestrict : false}
      />
    </HStack>
  );

  const PendingData = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: renderPhoneWithWa(data?.phone),
      approve: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="40px"
          icon={<FcApprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(approveStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
      ),
      reject: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<FcDisapprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(rejectStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isRestrict : false}
        />
      ),
    };
  });
  const pendingColumns = [
    {
      Header: "Student ID",
      accessor: "index",
    },
    {
      Header: "Student Name",
      accessor: "student_name",
    },
    {
      Header: "Phone",
      accessor: "phone",
    },
    {
      Header: "Group",
      accessor: "group_name",
    },
    {
      Header: "Approve",
      accessor: "approve",
    },
    {
      Header: "Reject",
      accessor: "reject",
    },
  ];

  const Data = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: renderPhoneWithWa(data?.phone),
      parent_phone: renderPhoneWithWa(data?.parent_phone),
      code: renderQrTrigger(data),
      actions: renderApprovedActionsToolbar(data),
      subject_name: data?.subject?.name,
    };
  });
  const columns = [
    {
      Header: "ID",
      accessor: "index",
    },
    {
      Header: "Name",
      accessor: "student_name",
    },
    {
      Header: "Code",
      accessor: "user_name",
    },
    ...(isSuperAdmin
      ? [
        {
          Header: "Subject",
          accessor: "subject_name",
        },
      ]
      : []),
    {
      Header: "Group",
      accessor: "group_name",
    },
    {
      Header: "QR",
      accessor: "code",
    },
    {
      Header: "Phone",
      accessor: "phone",
    },
    {
      Header: "Parent",
      accessor: "parent_phone",
    },
    {
      Header: "Actions",
      accessor: "actions",
    },

  ];

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = adminPillSelectStyles({ menuZIndex: 20 });

  return (
    <>
      <Box px={{ base: 4, md: 8 }} pt={6} pb={10} w="100%">
        <Flex
          align={{ base: "flex-start", md: "flex-end" }}
          justify="space-between"
          gap={6}
          flexDir={{ base: "column", md: "row" }}
          mb={8}
        >
          <Box>
            <Text
              fontSize={{ base: "32px", md: "54px" }}
              fontWeight="800"
              color={brandPalette.primary}
              fontFamily="'Amiri', 'Tajawal', sans-serif"
              lineHeight="1"
            >
              Student List
            </Text>
            <Text mt={3} color="rgba(30, 27, 23, 0.6)" fontSize="sm">
              Manage academic records and personal data for institution students
            </Text>
          </Box>

          <Flex gap={3} align="center" flexWrap="wrap">
            <Button
              borderColor={brandPalette.primary}
              border="1px solid"
              borderRadius="full"
              leftIcon={<RiFileExcel2Line />}
              color={brandPalette.primary}
              bg="var(--surface-muted)"
              _hover={{ bg: "rgba(233, 226, 219, 0.6)" }}
              position="relative"
            >
              <Text>Add Students in Bulk</Text>
              <Input
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const formData = new FormData();
                  formData.append("student_bulk", file);
                  dispatch(addBulkStudentRequest(formData));
                  e.target.value = "";
                }}
                type="file"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
                left="0"
                top="0"
                cursor="pointer"
              />
            </Button>

            <Box
              sx={{
                "& button": {
                  borderRadius: "9999px",
                  border: `1px solid ${brandPalette.stone}`,
                  background: "rgba(255,255,255,0.75)",
                  color: brandPalette.accentDark,
                  fontWeight: 700,
                },
                "& button:hover": {
                  background: "rgba(233, 226, 219, 0.6)",
                },
              }}
            >
              <ExportUsersButton />
            </Box>

            <Button
              borderRadius="full"
              bg={brandPalette.primary}
              color={brandPalette.cream}
              px={8}
              py={6}
              fontWeight="800"
              _hover={{ bg: brandPalette.accentDark }}
              onClick={() => {
                setAdd(true);
                dispatch(openCreateStudent());
              }}
            >
              + Add New Student
            </Button>
          </Flex>
        </Flex>

        <Box mt={6} mb={6}>
          <InputGroup maxW="520px">
            <InputLeftElement pointerEvents="none">
              <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
            </InputLeftElement>
            <Input
              placeholder="Search for student..."
              borderRadius="full"
              border="1px solid"
              borderColor={brandPalette.stone}
              bg="transparent"
              _focus={{ borderColor: brandPalette.primary }}
              onChange={(e) => setSearchTerm?.(e.target.value)}
            />
          </InputGroup>
        </Box>

        <Flex
          align="center"
          gap={3}
          mb={4}
          flexWrap="wrap"
          justify="flex-start"
        >
          <Button
            size="sm"
            borderRadius="full"
            bg={tab === "approve" ? brandPalette.primary : "transparent"}
            color={tab === "approve" ? "white" : brandPalette.primary}
            border="1px solid"
            borderColor={brandPalette.stone}
            _hover={{ bg: tab === "approve" ? brandPalette.accentDark : "rgba(216, 206, 195, 0.35)" }}
            onClick={() => setTab("approve")}
          >
            Approved
          </Button>
          <Button
            size="sm"
            borderRadius="full"
            bg={tab === "pending" ? brandPalette.primary : "transparent"}
            color={tab === "pending" ? "white" : brandPalette.primary}
            border="1px solid"
            borderColor={brandPalette.stone}
            _hover={{ bg: tab === "pending" ? brandPalette.accentDark : "rgba(216, 206, 195, 0.35)" }}
            onClick={() => setTab("pending")}
          >
            Pending
          </Button>

          {tab === "approve" && (
            <Box minW={{ base: "260px", md: "320px" }}>
              <Select
                options={groupsOptions}
                isMulti={false}
                isClearable
                onChange={(data) => {
                  setStudentGroupId(data?.value || "");
                }}
                styles={colourStyles}
                placeholder="Select Group"
              />
            </Box>
          )}
        </Flex>

        <Box
          bg="var(--surface-raised)"
          border="1px solid"
          borderColor="var(--border-subtle)"
          borderRadius="16px"
          overflow="hidden"
          boxShadow="sm"
        >
          {isLoading ? (
            <Box display={{ base: "block", md: "none" }} py={10} textAlign="center" px={4}>
              <Text color="var(--text-muted)">Loading students…</Text>
            </Box>
          ) : (
            <VStack
              display={{ base: "flex", md: "none" }}
              spacing={4}
              align="stretch"
              px={{ base: 3, sm: 4 }}
              py={4}
            >
              {tab === "approve"
                ? studentsList?.map((data, index) => (
                    <Box
                      key={data.id}
                      borderWidth="1px"
                      borderColor="var(--border-subtle)"
                      borderRadius="xl"
                      bg="var(--surface-muted)"
                    >
                      <Box p={4}>
                        <Flex justify="space-between" gap={3} align="flex-start">
                          <Box flex="1" minW={0}>
                            <Text
                              fontSize="xs"
                              fontWeight="700"
                              color="var(--text-muted)"
                              textTransform="uppercase"
                              letterSpacing="0.04em"
                            >
                              Student
                            </Text>
                            <Text
                              fontWeight="800"
                              fontSize="md"
                              color="var(--text-primary)"
                              cursor="pointer"
                              noOfLines={3}
                              onClick={() => {
                                viewData(data);
                                dispatch(openStudentReportModel());
                              }}
                            >
                              {data?.name}
                            </Text>
                            <Text fontSize="sm" color="var(--text-muted)" mt={1}>
                              ID #{index + 1} · Code {data?.user_name || "—"}
                            </Text>
                          </Box>
                          {renderQrTrigger(data)}
                        </Flex>

                        <SimpleGrid
                          columns={{ base: 1, sm: isSuperAdmin ? 2 : 1 }}
                          spacing={3}
                          mt={4}
                        >
                          <Box>
                            <Text
                              fontSize="xs"
                              fontWeight="700"
                              color="var(--text-muted)"
                              textTransform="uppercase"
                            >
                              Group
                            </Text>
                            <Text fontSize="sm" fontWeight="600" color="var(--text-primary)">
                              {data?.group?.name || "—"}
                            </Text>
                          </Box>
                          {isSuperAdmin ? (
                            <Box>
                              <Text
                                fontSize="xs"
                                fontWeight="700"
                                color="var(--text-muted)"
                                textTransform="uppercase"
                              >
                                Subject
                              </Text>
                              <Text fontSize="sm" fontWeight="600" color="var(--text-primary)">
                                {data?.subject?.name || "—"}
                              </Text>
                            </Box>
                          ) : null}
                        </SimpleGrid>

                        <Divider my={4} borderColor="var(--border-subtle)" />

                        <Box>
                          <Text
                            fontSize="xs"
                            fontWeight="700"
                            color="var(--text-muted)"
                            textTransform="uppercase"
                            mb={2}
                          >
                            Phone
                          </Text>
                          {renderPhoneWithWa(data?.phone)}
                        </Box>

                        <Box mt={3}>
                          <Text
                            fontSize="xs"
                            fontWeight="700"
                            color="var(--text-muted)"
                            textTransform="uppercase"
                            mb={2}
                          >
                            Parent
                          </Text>
                          {renderPhoneWithWa(data?.parent_phone)}
                        </Box>

                        <Divider my={4} borderColor="var(--border-subtle)" />

                        {renderApprovedActionsToolbar(data)}
                      </Box>
                    </Box>
                  ))
                : studentsList?.map((data, index) => (
                    <Box
                      key={data.id}
                      borderWidth="1px"
                      borderColor="var(--border-subtle)"
                      borderRadius="xl"
                      bg="var(--surface-muted)"
                    >
                      <Box p={4}>
                        <Text
                          fontSize="xs"
                          fontWeight="700"
                          color="var(--text-muted)"
                          textTransform="uppercase"
                          letterSpacing="0.04em"
                        >
                          Pending approval
                        </Text>
                        <Text
                          fontWeight="800"
                          fontSize="md"
                          color="var(--text-primary)"
                          cursor="pointer"
                          noOfLines={3}
                          onClick={() => {
                            viewData(data);
                            dispatch(openStudentReportModel());
                          }}
                        >
                          {data?.name}
                        </Text>
                        <Text fontSize="sm" color="var(--text-muted)" mt={1}>
                          Request #{index + 1}
                        </Text>

                        <Box mt={4}>
                          <Text
                            fontSize="xs"
                            fontWeight="700"
                            color="var(--text-muted)"
                            textTransform="uppercase"
                            mb={2}
                          >
                            Phone
                          </Text>
                          {renderPhoneWithWa(data?.phone)}
                        </Box>

                        <Box mt={3}>
                          <Text
                            fontSize="xs"
                            fontWeight="700"
                            color="var(--text-muted)"
                            textTransform="uppercase"
                            mb={1}
                          >
                            Group
                          </Text>
                          <Text fontSize="sm" fontWeight="600" color="var(--text-primary)">
                            {data?.group?.name || "—"}
                          </Text>
                        </Box>

                        <Divider my={4} borderColor="var(--border-subtle)" />

                        {renderPendingActionsToolbar(data)}
                      </Box>
                    </Box>
                  ))}
            </VStack>
          )}

          <CTable
            selectedData={viewData}
            Columns={tab === "approve" ? columns : pendingColumns}
            Data={tab === "approve" ? Data : PendingData}
            Actions={false}
            setPage={setPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            isLoading={isLoading}
            totalPage={Math.ceil(count / 50)}
            wrapperProps={{
              maxH: "unset",
              overflow: "auto",
              display: { base: "none", md: "block" },
            }}
            tableProps={{ bg: "transparent", borderRadius: "0" }}
            theadProps={{ bg: "var(--surface-muted)", color: "var(--text-primary)" }}
          />
        </Box>
      </Box>

      {/* Suspend Reason Modal */}
      <SuspendReasonModal studentData={suspendStudent} />
    </>
  );
};

export default CirclesStudentsTable;
